import * as React from "react";
import {
  List, Datagrid, NumberField, FunctionField,
} from "react-admin";
import { Avatar, Box } from "@mui/material";

// Classement patients — GET /patient-ranking renvoie { entries, totalElements... }
// extraction via transformList dans resourceMap.
// PatientRankingEntryDTO : id, firstName, lastName, photoUrl, arca, rank, isCurrentUser.
export default {
  list: () => (
    <List perPage={50} pagination={false} title="Classement des patients">
      <Datagrid bulkActionButtons={false} rowClick={false}>
        <NumberField locales="fr-FR" source="rank" label="Rang" />
        <FunctionField label="Patient" render={(r) => (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Avatar src={r?.photoUrl} sx={{ width: 32, height: 32, bgcolor: "secondary.main", fontSize: 14 }}>
              {((r?.firstName || "")[0] || "") + ((r?.lastName || "")[0] || "")}
            </Avatar>
            <Box>
              <Box sx={{ fontWeight: 600 }}>{r?.firstName} {r?.lastName}</Box>
              {r?.id && (
                <a href={`#/patients/${r.id}/show`} style={{ color: "#0d7377", fontSize: 12 }}>
                  Voir la fiche →
                </a>
              )}
            </Box>
          </Box>
        )} />
        <NumberField locales="fr-FR" source="arca" label="ArcA" />
      </Datagrid>
    </List>
  ),
};
